import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Brand from "@/components/Brand";
import SiteHead from "@/components/SiteHead";
import api from "@/lib/api";
import { BRAND_NAME, FOUNDER_NAME } from "@/lib/brand";

export default function CityPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setDoc(null);
    setErr(false);
    api.get(`/cities/${slug}`).then(({ data }) => setDoc(data)).catch(() => setErr(true));
  }, [slug]);

  if (err) {
    return (
      <div className="min-h-screen lp-paper flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-stone-600">This city guide is not published.</p>
          <Link to="/" className="text-orange-700 font-semibold underline">Home</Link>
        </div>
      </div>
    );
  }
  if (!doc) return <div className="min-h-screen lp-paper" />;

  const extraJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: doc.meta_title || doc.title,
    about: { "@type": "Place", name: doc.name, addressCountry: "IN" },
    author: { "@type": "Person", name: FOUNDER_NAME },
  };

  return (
    <div className="lp-paper text-stone-900 min-h-screen font-sans antialiased">
      <SiteHead
        title={doc.meta_title || `${doc.title} · ${BRAND_NAME}`}
        description={doc.meta_description || doc.excerpt}
        path={`/cities/${slug}`}
        faq={doc.faq}
        extraJsonLd={extraJsonLd}
        keywords={`${doc.name}, ecommerce website, ${BRAND_NAME}`}
      />
      <header className="sticky top-0 z-50 border-b border-stone-900/10 bg-[#FBF7F0]/85 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><Brand variant="light" size="xl" /></Link>
          <Link to="/blog" className="text-sm font-medium text-stone-600">Blog</Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        <div className="blog-prose" dangerouslySetInnerHTML={{ __html: doc.body_html || "" }} />
        <div className="mt-12 rounded-2xl bg-orange-500 border-2 border-stone-900 p-6 text-white">
          <h2 className="font-display text-2xl font-extrabold">Start your store in {doc.name}</h2>
          <Link to="/signup?plan=website" className="mt-4 inline-block rounded-full bg-white text-stone-900 font-bold px-5 py-2.5 border-2 border-stone-900">Get Started</Link>
        </div>
      </article>
    </div>
  );
}
